import { forwardRef } from 'react'
import { IconProps } from 'almanac-ui/icons/Types'

export const Preference = forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', size = 16 }, forwardedRef) => {
    return (
      <svg
        width={size}
        height={size}
        style={{ width: size, height: size }}
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        ref={forwardedRef}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6 4C6 4.55228 5.55228 5 5 5C4.44772 5 4 4.55228 4 4C4 3.44772 4.44772 3 5 3C5.55228 3 6 3.44772 6 4ZM6.93699 3.5C6.71497 2.63739 5.93192 2 5 2C4.06808 2 3.28503 2.63739 3.06301 3.5H2C1.72386 3.5 1.5 3.72386 1.5 4C1.5 4.27614 1.72386 4.5 2 4.5H3.06301C3.28503 5.36261 4.06808 6 5 6C5.93192 6 6.71497 5.36261 6.93699 4.5H14C14.2761 4.5 14.5 4.27614 14.5 4C14.5 3.72386 14.2761 3.5 14 3.5H6.93699ZM14.5 8C14.5 8.27614 14.2761 8.5 14 8.5H12.937C12.715 9.36261 11.9319 10 11 10C10.0681 10 9.28503 9.36261 9.06301 8.5L2 8.5C1.72386 8.5 1.5 8.27614 1.5 8C1.5 7.72386 1.72386 7.5 2 7.5L9.06301 7.5C9.28503 6.63739 10.0681 6 11 6C11.9319 6 12.715 6.63739 12.937 7.5H14C14.2761 7.5 14.5 7.72386 14.5 8ZM10 8C10 8.55228 10.4477 9 11 9C11.5523 9 12 8.55228 12 8C12 7.44772 11.5523 7 11 7C10.4477 7 10 7.44771 10 8ZM1.5 12C1.5 11.7239 1.72386 11.5 2 11.5H3.06301C3.28503 10.6374 4.06808 10 5 10C5.93192 10 6.71497 10.6374 6.93699 11.5H14C14.2761 11.5 14.5 11.7239 14.5 12C14.5 12.2761 14.2761 12.5 14 12.5H6.93699C6.71497 13.3626 5.93192 14 5 14C4.06808 14 3.28503 13.3626 3.06301 12.5H2C1.72386 12.5 1.5 12.2761 1.5 12ZM6 12C6 11.4477 5.55228 11 5 11C4.44772 11 4 11.4477 4 12C4 12.5523 4.44772 13 5 13C5.55228 13 6 12.5523 6 12Z"
          fill={color}
        />
      </svg>
    )
  },
)

export default Preference
